import { LazyLoad } from 'app/utils';

export const ContactCategorySortPage = LazyLoad(
  () => import('./index'),
  (module) => module.ContactCategorySortPage,
);
